import React, { useState } from "react";
import { Input } from "antd";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import "./inputBox.scss";

const { TextArea } = Input;

const InputBox = ({
  label,
  placeholder,
  type,
  isMultiline,
  rows = 4,
  ...props
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (  
    <div className="custom-input-container">
      {label && <label className="custom-label">{label}</label>}
      <div className="input-wrapper">
        {isMultiline ? (
          <TextArea placeholder={placeholder} rows={rows} {...props} />
        ) : (
          <Input
            placeholder={placeholder}
            type={
              type === "password" && !isPasswordVisible ? "password" : "text"
            }
            {...props}
            suffix={
              type === "password" ? (
                isPasswordVisible ? (
                  <EyeInvisibleOutlined
                    onClick={() => setIsPasswordVisible(false)}
                    className="password-icon"
                  />
                ) : (
                  <EyeOutlined
                    onClick={() => setIsPasswordVisible(true)}
                    className="password-icon"
                  />
                )
              ) : null
            }
          />
        )}
      </div>
    </div>
  );
};

export default InputBox;
